import type { AssetAvailability } from '../../../api/types';
import { spaceOf } from '../../../utils/useCases';

/**
 * The use case a blocker is created with: the asset's event-room use case,
 * and an apartment otherwise — a fall-through kept as it was (the use-case
 * sweep changes no behaviour; docs/reviews/use-case-name-sites-inventory.md).
 */
export const blockerUseCaseOf = (asset: Pick<AssetAvailability, 'useCases'> | null | undefined): string =>
    // The canonical key, never the raw element: it goes into the request body.
    asset?.useCases?.find((uc) => spaceOf(uc)?.flow === 'event')?.trim().toLowerCase() ?? 'apartment';
